export default {
    configName: 'lfl36',
    appTitle: 'ЛФЛ Воронеж | LFL36.RU',
    federation: {
        _id: '6246dd6b1fdbc63aa35507ca'
    },
    bannerNode: {
        media: `${process.env.FILES_BUCKET}storage/banner_36.jpg`,
        publicationId: null,
        externalLink: 'https://vk.ru/wall-103929250_30312'
    },
    brandEmblem: `${process.env.FILES_BUCKET}apps/voronezh_260.png`,
    topBanners: [
        `${process.env.FILES_BUCKET}apps_promo/lfl36/1.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/2.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/3.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/5.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/9.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/10.png`
    ],
    topLinks: [
        'https://vk.com/atlant_136',
        'https://agroeco.ru/?ysclid=mggx52dopu24868270',
        'https://vk.com/dodo_voronezh',
        'https://vk.com/boston_barbershop',
        'https://vk.com/gellert_bar_vrn',
        'https://vk.com/sc_metallist'
    ],
    footerCreds: {
        copyright: '© АНФСО Любительская Футбольная Лига Воронеж, 2022 - 2024',
        phone: '+7 (903) 652 42 97',
        address: '394002, г. Воронеж, улица Ржевская, дом 11'
    },
    footerStores: null,
    footerBanners: [
        `${process.env.FILES_BUCKET}apps_promo/lfl36/10.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/11.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/12.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/13.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/14.png`,
        `${process.env.FILES_BUCKET}apps_promo/lfl36/15.png`,
    ],
    footerLinks: [
        'https://vk.com/magazinturnir',
        'https://vk.com/fifauefavrn',
        'https://foodruskon.ru/',
        'https://vk.com/banyametallist',
        'https://olimp03.ru',
        'https://www.evkaliptmed.ru/'

    ],
    footerSocials: {
        vk: 'https://vk.com/lflvoronezh',
        telegram: 'https://t.me/lfl36',
        youtube: 'https://youtube.com/@LFLVoronezh'
    },
    fantasyBrand: {
        type: 'label',
        text: 'Amateum',
        link: null
    },
    metrikaCounter: 89111502,
    firebase: {
        config: {
          apiKey: "AIzaSyAeNtnfS8zOr8wKcOWNi8sRzGfojTe6a_0",
          authDomain: "amateum-bb5a1.firebaseapp.com",
          projectId: "amateum-bb5a1",
          storageBucket: "amateum-bb5a1.appspot.com",
          messagingSenderId: "456338694560",
          appId: "1:456338694560:web:87830ca76300208a4784c5",
          measurementId: "G-7HY1ZRCYFJ"
        },
        vapid: 'BBSkT_vcHGt2nxpZathVaRcJp5Q73gimRpH-njPUWOE2P_eUXKN-HN4pyl_McYV5f3LUgd43-jvP8SbZVWF1dRE'
    }
}
